'use es6';

import { callWidgetDrilldown } from '../lib/salesAnalytics/drilldowns';
import { isReportAccumulative } from '../lib/salesAnalytics/helpers';
export const AGGREGATION_PROPS = ['hubspot_team_id', 'hubspot_owner_id', 'hs_manual_forecast_category', 'SUM|count', 'SUM|amountInHomeCurrency', 'SUM|projectedAmountInHomeCurrency', 'SUM|hs_projected_amount_in_home_currency', 'SUM|closedAmountInHomeCurrency', 'SUM|hs_closed_amount_in_home_currency', 'quotaAmount', 'accumulatedQuota', 'forecastAmount', 'attainmentPercentage', 'gapToQuota', 'dealstage', 'hs_analytics_source', 'closedate'];
export const getStaticColumns = ({
  report,
  bucketField,
  metricField,
  onDrilldown
}) => {
  if (isReportAccumulative(report)) {
    // When "Over time" report
    return [{
      field: bucketField,
      dataset: 'primary'
    }, {
      field: 'SUM|count',
      dataset: 'primary',
      onClick: callWidgetDrilldown(report, onDrilldown)
    }, {
      field: `SUM|${metricField}`,
      dataset: 'primary'
    }, {
      field: 'quotaAmount',
      dataset: 'primary'
    }, {
      field: 'accumulatedQuota',
      dataset: 'primary'
    }, {
      dataset: 'primary',
      field: 'attainmentPercentage'
    }, {
      dataset: 'primary',
      field: 'gapToQuota'
    }];
  }
  return [{
    field: bucketField,
    dataset: 'primary'
  }, {
    field: 'SUM|count',
    dataset: 'primary',
    onClick: callWidgetDrilldown(report, onDrilldown)
  }, {
    field: `SUM|${metricField}`,
    dataset: 'primary'
  }, {
    field: 'quotaAmount',
    dataset: 'primary'
  }, {
    dataset: 'primary',
    field: 'attainmentPercentage'
  }, {
    dataset: 'primary',
    field: 'gapToQuota'
  }];
};